module.exports = __webpack_public_path__ + "static/media/service-list-mobile.ef544a8f.jpg";